module.exports = __webpack_public_path__ + "static/media/up-arrow.94fb507a.svg";